import React from 'react';

export const CheckboxPreview = ({ component, onClick, isSelected }) => {
  const { commonAttrs, specificAttrs } = component;
  
  const containerStyle = {
    padding: `${commonAttrs.paddingTop}px ${commonAttrs.paddingRight}px ${commonAttrs.paddingBottom}px ${commonAttrs.paddingLeft}px`,
    margin: `${commonAttrs.marginTop}px ${commonAttrs.marginRight}px ${commonAttrs.marginBottom}px ${commonAttrs.marginLeft}px`,
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    cursor: 'pointer',
    border: isSelected ? '2px solid #3B82F6' : '2px solid transparent',
    borderRadius: '4px',
  };

  const checkboxStyle = {
    width: '18px',
    height: '18px',
    cursor: 'pointer'
  };

  const labelStyle = {
    fontSize: '14px',
    color: '#374151',
    cursor: 'pointer'
  };

  const helpTextStyle = {
    fontSize: '12px',
    color: '#6B7280',
    marginLeft: '26px'
  };

  return (
    <div onClick={onClick}>
      <div style={containerStyle}>
        <input
          type="checkbox"
          name={specificAttrs.name}
          checked={specificAttrs.checked}
          disabled={specificAttrs.disabled}
          style={checkboxStyle}
          readOnly
        />
        <label style={labelStyle}>{specificAttrs.label || 'Checkbox'}</label>
      </div>
      {specificAttrs.helpText && <p style={helpTextStyle}>{specificAttrs.helpText}</p>}
    </div>
  );
};
